package org.hs_soft.runmynesto.domain.config.language

object FrenchStrings : StringResources{
    override val given = "Donné"
    override val receiptNo = "N° de reçu"
    override val billNumberFrom: String = "Numéro de Facture (de)"
    override val BillNumberTo: String = "Numéro de Facture (à)"
    override val totalTo: String = "Total (à)"
    override val totalFrom: String = "Total (de)"
    override val receiptsList = "Liste des reçus"
    override val dragColumnHint="Faites glisser un en-tête de colonne ici pour le regrouper par cette colonne"
    override val selectCashRegisters="Sélectionner les caisses"
    override val priceCategory = "Catégorie de prix"
    override val fixedProducts = "Produits fixes"
    override val gang="Groupe"
    override val addNewSelection="Ajouter une nouvelle sélection"
    override val quantity = "Quantité"
    override val fixedQuantity = "Quantité Fixe"
    override val maxQuantity = "Quantité Maximum"
    override val minQuantity = "Quantité Minimum"
    override val isTheMenuName = "Est le nom du menu"
    override val selection = "Sélection"
    override val addNewPrice="Ajouter un nouveau prix"
    override val endTime="Heure de fin"
    override val individualPrice="Prix Individuel"
    override val numberOfButtons="Nombre de boutons"
    override val sorting = "Tri"
    override val sortingAutoByName = "Trié par nom"
    override val sortingAutoByNumber = "Trié par numéro"
    override val sortingManual = "Manuel"
    override val doYouWantToRemove="Voulez-vous supprimer"
    override val error = "Erreur"
    override val availableEveryWhere: String = "Disponible Partout"
    override val singleRightDoor: String = "Porte simple droite"
    override val singleLeftDoor: String = "Porte simple gauche"
    override val floors = "Étages"
    override val newRoomName = "Nouveau nom de la salle"
    override val enterProductNumber: String = "Entrez le numéro du produit"
    override val enterProductName: String = "Entrez le nom du produit"
    override val enterMediaNumber: String = "Entrez le numéro du média"
    override val enterMediaName: String = "Entrez le nom du média"
    override val enterSaleGroupName: String = "Entrez le nom du groupe de vente"
    override val enterSaleGroupNumber: String = "Entrez le numéro du groupe de vente"
    override val enterCategoryName: String = "Entrez le nom de la catégorie"
    override val enterCategoryNumber: String = "Entrez le numéro de la catégorie"
    override val enterUserName: String = "Entrez le nom d'utilisateur"
    override val enterUserNumber: String = "Entrez le numéro d'utilisateur"
    override val enterLocationName: String = "Entrez le nom de l'emplacement"
    override val enterLocationNumber: String = "Entrez le numéro de l'emplacement"
    override val multiFactorAuthentication="Authentification à Plusieurs Facteurs"
    override val signIn="Se connecter"
    override val enterLoginRequiredData="Veuillez saisir les données requises pour vous connecter au système."
    override val verificationInfo="Votre compte est sécurisé à l'aide de l'Authentification à Plusieurs Facteurs (MFA). Veuillez saisir le code d'authentification suivant pour terminer la connexion"
    override val noData="Aucune Donnée"
    override val shopName="Nom du Magasin"
    override val edit="Modifier"
    override val price3="Prix 3"
    override val altName="Nom alternatif de l'article"
    override val salesUnit="Unité de vente"
    override val presetRoom="Salle préréglée"
    override val priceShowOnKitchenReceipt="Afficher le prix sur le reçu de cuisine"
    override val printDishesOfTheNextCourse="Imprimer les plats du prochain cours"
    override val store="Magasin"
    override val poiId = "ID POI"
    override val liveEndpointUrlPrefix = "Préfixe d'URL du Point de Terminaison en Direct"
    override val apiKey = "Clé API"
    override val applicationKey = "Clé d'Application"
    override val roomId = "ID de Salle"
    override val virtualTerminalId = "ID de Terminal Virtuel"
    override val terminalId = "ID de Terminal"
    override val userId = "ID d'Utilisateur"
    override val posID="ID POS"
    override val tId="TID"
    override val hardware="Matériel"
    override val creditCardLink="Lien carte de crédit"
    override val openCashDrawerAfterEFTTransaction="Ouvrir le tiroir-caisse après la transaction EFT"
    override val tcpIP="TCP/IP"
    override val terminal="Terminal"
    override val tse="TSE"
    override val eftTerminal="Terminal EFT"
    override val activate="Activer"
    override val adminPin="PIN Admin"
    override val adminPUK="PUK Admin"
    override val tseType="Type TSE"
    override val printQRCode="Imprimer QR-Code"
    override val timeadminPin="PIN Timeadmin"
    override val timeadminPUK="PUK Timeadmin"
    override val tseLocation="Emplacement TSE"
    override val tseInformation="Information TSE"
    override val activeKitchenPrinter="Imprimante de cuisine active"
    override val printReceiptAfterCompletion="Imprimer le reçu après la finalisation"
    override val printKitchenOnlyForTables="Imprimer la cuisine uniquement pour les tables"
    override val kitchenLocations="Emplacements de cuisine"
    override val topEdgeCm="Bord supérieur (cm)"
    override val separateCakeToppings="Garnitures de gâteau séparées"
    override val tableShift="Décalage de table"
    override val uploadImgInfoSize="256x256 px"
    override val apaleoPMSSubAccounts="Sous-comptes Apaleo PMS"
    override val uploadImgInfoType="JPG, PNG"
    override val uploadManually="Télécharger manuellement"
    override val generateUsingAI="Générer avec l'IA"
    override val updatingApaleoPaymentWithCashRegister="Mise à jour des méthodes de paiement Apaleo avec les méthodes de paiement de la caisse"
    override val selectSalesGroupsForApaleoSubaccounts="Sélectionner les groupes de vente pour les sous-comptes Apaleo"
    override val clientId="ID Client"
    override val clientSecret="Secret Client"
    override val export="Exporter"
    override val noValidIPAddress="Adresse IP non valide"
    override val apaleoPMSProperty="Propriété Apaleo PMS"
    override val port="Port"
    override val pmsType="Type PMS"
    override val printReceiptAutomatically="Imprimer le reçu automatiquement"
    override val transferAllDocuments="Transfert de tous les documents"
    override val pms="PMS"
    override val createCard="Créer carte"
    override val loading="Chargement..."
    override val selected="Sélectionné"
    override val category="Catégorie"
    override val turnoverGroup="Groupe de Chiffre d'Affaires"
    override val ingredients="Ingrédients"
    override val productNumber="Numéro de Produit"
    override val alcoholic="Alcoolisé"
    override val vegan="Végétalien"
    override val vegetarian="Végétarien"
    override val disable="Désactivé"
    override val protel="Protel"
    override val apaleo="Apaleo"
    override val lookingForAnswer="Recherche d'une réponse..."
    override val tel="Tél"
    override val shopsExclusiveTemplate="Modèle exclusif des magasins"
    override val position="Position"
    override val comparedToPreviousWeek="Par rapport aux revenus de la semaine dernière, même jour"
    override val printerLocations="Emplacements d'imprimante"
    override val setDefaultValuesForNewCustomer="Définir les valeurs par défaut pour un nouveau client"
    override val paymentMethods="Méthodes de Paiement"
    override val save="Enregistrer"
    override val disableContentOnDevice="Désactiver le contenu sur l'appareil"
    override val transferSettingFromCashRegister="Transférer les paramètres de la caisse"
    override val androidSerialNumber="Numéro de série Android"
    override val cashRegisterType="Type de caisse"
    override val addNewBusinessOfficeDE="Ajouter un nouveau bureau d'affaires"
    override val addNewRegionDE="Ajouter une nouvelle région"
    override val addNewBranchDE="Ajouter une nouvelle succursale"
    override val addNewCashRegisterDE="Ajouter une nouvelle caisse"
    override val addNewDevice="Ajouter un nouvel appareil"
    override val vatNormal="TVA normale"
    override val vatReduced="TVA réduite"
    override val vatFree="Pas de TVA"
    override val vatSpecial="TVA spéciale"
    override val delete="Supprimer"
    override val copy="Copier"
    override val tableNumber="Numéro de Table"
    override val enterTableNumber="Saisissez le numéro de table"
    override val seats="Places"
    override val restoMate="RestoMate"
    override val restoMateDescription="Votre compagnon de restaurant alimenté par l'IA"
    override val dataAssistantDatabaseLoadingTitle="Votre base de données est en cours de chargement..."
    override val dataLoadingProgressCategoryImportTitle="Les catégories sont en cours de téléchargement..."
    override val dataLoadingProgressMenuCardImportTitle="Votre carte de menu est téléchargée"
    override val editFloor="Modifier l'étage"
    override val list="Liste"
    override val tiles="Tuiles"
    override val desktopWaiter="Serveur Bureau"
    override val mobileWaiter="Serveur Mobile"
    override val listingLayout="Disposition de la Liste"
    override val device="Appareil"
    override val cash="Espèces"
    override val eft="EFT"
    override val tips="Pourboires"
    override val revenueGuest="Revenu/Client"
    override val totalRevenue="Revenu total"
    override val analizeQuestionProcess="Analyse de la question..."
    override val generateSQLProcess="Génération SQL..."
    override val formatAnswerProcess="Formatage SQL..."
    override val createFilesProcess="Création de fichiers..."
    override val uploadFilesProcess="Téléchargement des fichiers..."
    override val generateMenuCardProcess="Génération de la carte du menu..."
    override val clearMenuCardProcess="Effacement de la carte du menu..."
    override val prepareResultProcess="Préparation du résultat..."
    override val menuCardProgressMessage="étapes sont terminées"
    override val menuCardSelectFilesMessages="Choisissez des fichiers (.pdf, .png, .jpg) pas plus grands que 3MB"
    override val filesChosen="fichier(s) choisi(s)"
    override val uploaded="téléchargé"
    override val generalInfo="Information Générale"
    override val download="Télécharger"
    override val doYouWantToRemoveThisFloor="Voulez-vous supprimer cet étage?"
    override val doYouWantToRemoveThisRoom="Voulez-vous supprimer cette salle?"
     override val floorNumber="Numéro d'étage"
    override val addNewFloor="Ajouter un nouvel étage"
    override val wall="Mur"
    override val floor="Étage"
    override val show3D="Afficher 3D"
    override val addFloor="Ajouter un étage"
    override val interiorDecor="Décoration Intérieure"
    override val add="Ajouter"
    override val table="Table"
    override val roomName="Nom de Salle"
    override val projectName="Nom du Projet"
    override val restaurantManager="Gestionnaire de Restaurant"
    override val addNewGroup="Ajouter un nouveau groupe"
    override val editGroup="Modifier Groupe"
    override val shopaffiliation="Affiliation de magasin"
    override val dateInterval="Intervalle de date"
    override val selfCheckout_1080_1920="Auto-paiement (1024*600)"
    override val standard_1024_600="Standard (1024*600)"
    override val addNewMedia="Ajouter un nouveau média"
    override val refreshTime="Temps d'actualisation"
    override val chooseAnArticle="Choisir un Article"
    override val advertisingDuringTyping="Publicité pendant la saisie"
    override val fullDisplayAdvertising="Publicité en plein écran"
    override val stayActive="Rester Actif"
    override val media="Média"
    override val mediaCenter="Centre Média"
    override val actions="Actions"
    override val disableCompletion="Désactiver la complétion"
    override val reason="Raison"
    override val deactivateDailyClosing="Désactiver la fermeture quotidienne"
    override val group="Groupe"
    override val groupByDateShop="Grouper par Date/Magasin"
    override val groupByShop="Grouper par Magasin"
    override val groupByDate="Grouper par Date"
    override val inTotal="Au Total"
    override val printFinancialStatements="Imprimer les états financiers"
    override val selectedItem="Élément Sélectionné"
    override val exportExcel="Excel"
    override val price="Prix"
    override val percentSign="%"
    override val code="Code"
    override val productDateShop="Produit-Date-Magasin"
    override val productDate="Produit-Date"
    override val dateProduct="Date-Produit"
    override val productShop="Produit-Magasin"
    override val shopProduct="Magasin-Produit"
    override val lastSale="Dernière Vente"
    override val weight="Poids"
    override val firstSale="Première Vente"
    override val groupedBy="Groupé par"
    override val notCancelled="Non Annulé"
    override val cancelled="Annulé"
    override val userName="Nom d'Utilisateur"
    override val total="Total"
    override val cancellation="Annulation"
    override val pdf="PDF"
    override val abcStatistic="Statistique ABC"
    override val billSearch="Recherche de Facture"
    override val setting="Paramètre"
    override val statistic="Statistique"
    override val threeWeeksAgo="Il y a 3 semaines"
    override val twoWeeksAgo="Il y a 2 semaines"
    override val lastWeek="Semaine dernière"
    override val compare="Comparer"
    override val sales="Ventes"
    override val allTheRegions="Toutes les régions"
    override val clients="Clients"
    override val workingHours="Heures de travail"
    override val hourlyRate="Taux horaire"
    override val averageCheck="Vérification moyenne"
    override val turnOver="Chiffre d'affaires"
    override val euro="€"
    override val cashRegisters="Caisses"
    override val restaurantsOf="Restaurants de"
    override val dashboard="Tableau de bord"
    override val backgroundColor="Couleur d'arrière-plan"
    override val fakeLatestPurchasesAndMore="https://shortlink.com/**********"
    override val fakeQRCode="0000-0000-0000-0000"
    override val fakeCustomerNumber="0000001"
    override val incomeAndExpanse="Revenus et Dépenses"
    override val cashBookAndCoupons="Livre de caisse et Coupons"
    override val credit="Crédit"
    override val pressets="Préréglages"
    override val apply="Appliquer"
    override val amountCHF="Montant CHF"
    override val amount="Montant"
    override val difference="Différence"
    override val cashDelivery="Livraison en espèces"
    override val IsnInCHF="Est en CHF"
    override val course="Cours"
    override val lst="lst"
    override val currency="Devise"
    override val reduction="Réduction"
    override val freeVat="TVA Gratuite"
    override val empty="Vide"
    override val reports="Rapports"
    override val FROM_DATE="De Date"
    override val GROUP="groupe"
    override val BALANCE="solde"
    override val BOOKING_MODE="mode de réservation"
    override val UNTIL_DATE="Jusqu'à Date"
    override val CHECKOUT="Paiement"
    override val CREDIT="Crédit"
    override val POINTS="points"
    override val CHECKOUT_DATE="date de paiement"
    override val DESIGNATION="Désignation"
    override val DOCUMENT_NUMBER="numéro de document"
    override val BURDEN="Charge"
    override val POINTS_BALANCE="solde de points"
    override val CASH_REGISTER_TIME="heure de caisse"
    override val cashRegisterName="Nom de la Caisse"
    override val selectDesiredColumns="Sélectionner les colonnes désirées"
    override val transaction="Transactions"
    override val addNewCustomerCard="Ajouter une nouvelle carte client"
    override val digitalCustomerCard="Carte Client Numérique"
    override val rfidCustomerCard="Carte Client RFID"
    override val zeroSetting="Aucun Paramètre"
    override val none="Aucun"
    override val discountGroup1="Groupe de Remise 1"
    override val discountGroup2="Groupe de Remise 2"
    override val discountGroup3="Groupe de Remise 3"
    override val discountGroup4="Groupe de Remise 4"
    override val discountGroup5="Groupe de Remise 5"
    override val discountGroup6="Groupe de Remise 6"
    override val discountGroup7="Groupe de Remise 7"
    override val discountGroup8="Groupe de Remise 8"
    override val discountGroup9="Groupe de Remise 9"
    override val discountGroup10="Groupe de Remise 10"
    override val discountGroup11="Groupe de Remise 11"
    override val discountGroup12="Groupe de Remise 12"
    override val discountGroup13="Groupe de Remise 13"
    override val discountGroup14="Groupe de Remise 14"
    override val discountGroup15="Groupe de Remise 15"
    override val discountGroup16="Groupe de Remise 16"
    override val discountGroup17="Groupe de Remise 17"
    override val discountGroup18="Groupe de Remise 18"
    override val discountGroup19="Groupe de Remise 19"
    override val discountGroup20="Groupe de Remise 20"
    override val inHouseCard="Carte Interne"
    override val loyaltyCard="Carte de Fidélité"
    override val clientName="Nom du Client"
    override val salutation="Salutation"
    override val resetBooking="Réinitialiser la Réservation"
    override val cardHolder="Titulaire de Carte"
    override val loadLabels="Charger les Étiquettes"
    override val loadMaps="Charger les Cartes"
    override val loadingLabeling="Chargement/Étiquetage"
    override val labelingWorkCards="Étiquetage des Cartes de Travail"
    override val loadingWorkCards="Chargement des Cartes de Travail"
    override val createCustomerCard="Créer une Carte Client"
    override val until="Jusqu'à"
    override val from="De"
    override val loyaltyCards="Cartes de Fidélité"
    override val calculate="Calculer"
    override val end="Fin"
    override val start="Début"
    override val period="Période"
    override val January="Janvier"
    override val February="Février"
    override val March="Mars"
    override val April="Avril"
    override val May="Mai"
    override val June="Juin"
    override val July="Juillet"
    override val August="Août"
    override val September="Septembre"
    override val October="Octobre"
    override val November="Novembre"
    override val December="Décembre"
    override val fourQuarters="T4"
    override val threeQuarters="T3"
    override val twoQuarters="T2"
    override val oneQuarter="T1"
    override val twoHalfAYear="2ÈME MOITIÉ"
    override val oneHalfAYear="1ÈRE MOITIÉ"
    override val next="Suivant"
    override val previous="Précédent"
    override val previousWeek="Semaine Précédente"
    override val thisWeek="Cette Semaine"
    override val yesterday="Hier"
    override val today="Aujourd'hui"
    override val rfid="RFID"
    override val barcode="Code-barres"
    override val collectPointsWhenCharged="Collecter des points uniquement lors de la charge"
    override val cardCanOnlyBeChargedByCash="La carte ne peut être rechargée qu'avec de l'argent liquide"
    override val grantDiscountOnNetItems="Accorder également une remise sur les articles nets"
    override val grantDiscountWhenCharged="Accorder une remise uniquement lors de la charge"
    override val discountNumber="N° de Remise"
    override val discountGLWithPercent="Rabais GL, %"
    override val discountWithPercent="Remise, %"
    override val debitCard="Carte de Débit"
    override val cardType="Type de Carte"
    override val art="Art"
    override val owner="Propriétaire"
    override val email="Email"
    override val telephone="Téléphone"
    override val firstName="Prénom"
    override val address="Adresse"
    override val zipCity="Code Postal"
    override val cardLimit="Limite de carte"
    override val dailyLimit="Limite quotidienne"
    override val card="Carte"
    override val cardNumber="Numéro de carte"
    override val lastUsed="Dernière utilisation"
    override val internetAccessCode="Code d'accès Internet"
    override val series="Série"
    override val customerCards="Cartes clients"
    override val points="Points"
    override val ipAddress="Adresse IP"
    override val kitchenPrinterSerialNumber="Numéro de série de l'imprimante de cuisine"
    override val addCakeDisplay="Ajouter un affichage de gâteau"
    override val serialNumber="Numéro de série"
    override val logout="Déconnexion"
    override val backToAdmin="Retour au mode administrateur"
    override val myProfile="Mon profil"
    override val globalSearch="Recherche globale"
    override val noItemToDisplay="Aucun élément à afficher"
    override val standardInBracket="<Standard>"
    override val mwstNormal="TVA-Normale"
    override val salesVolume="Ventes"
    override val time="Heure"
    override val date="Date"
    override val closingReports="Rapports de Clôture"
    override val standardWithoutPrinting="Standard sans impression"
    override val withCashReportAndCountProtocol="Avec rapport de caisse et protocole de comptage"
    override val withoutCash="Sans espèces"
    override val standard="Standard"
    override val withCashReport="Avec rapport de caisse"
    override val vatRateSelection="Sélection du Taux de TVA"
    override val specialVat="TVA Spéciale"
    override val reducedVat="TVA Réduite"
    override val normalVat="TVA Normale"
    override val office="Bureau"
    override val priceLevel="Niveau de Prix"
    override val region="Région"
    override val priceLevelInHouseButton="Bouton Niveau de Prix en Interne"
    override val branch="Succursale"
    override val mode="Mode"
    override val cashierName="Nom du Caissier"
    override val copyForWaiter="Copie pour le serveur"
    override val printer="Imprimante"
    override val receiptCopy="Copie du Reçu"
    override val fromAmount="Du Montant"
    override val variable="Variable"
    override val inTheHouse="Dans-Maison"
    override val degree="Degré"
    override val activateEmployeeCompletion="Activer la complétion des employés"
    override val degreeType="Type de Degré"
    override val close="Fermer"
    override val previewForAppleWallet="Aperçu pour Apple Wallet"
    override val latestPurchasesAndMore="Derniers achats et plus"
    override val phone="Téléphone"
    override val qrCode="QR-Code"
    override val customerName="Nom du Client"
    override val customerNumber="Numéro de Client"
    override val cardName="Nom de la Carte"
    override val specialDiscountTier="Niveau de Remise Spéciale"
    override val discountTier="Niveau de Remise"
    override val aboutTheCard="Plus d'informations sur la carte au verso!"
    override val cashAssistCard="Carte Cash Assist"
    override val balance="Solde"
    override val customerCard="Carte Client"
    override val previewForGoogleWallet="Aperçu pour Google Wallet"
    override val cardPreview="Aperçu de la carte"
    override val cardInfoPreview="Aperçu des informations de la carte"
    override val cashRegisterConfig="Configuration de la Caisse"
    override val menuCardImport="Importation de la Carte du Menu"
    override val advertisingText="Texte Publicitaire"
    override val optionalTwo="Optionnel Deux"
    override val optionalOne="Optionnel Un"
    override val vatNumber="Numéro de TVA"
    override val addition="Ajout"
    override val mfaCode="Code-MFA"
    override val incomeExpanses="Rev/Dépenses"
    override val incomeExpanses1="Rev/Dépenses 1"
    override val incomeExpanses2="Rev/Dépenses 2"
    override val incomeExpanses3="Rev/Dépenses 3"
    override val incomeExpanses4="Rev/Dépenses 4"
    override val incomeExpanses5="Rev/Dépenses 5"
    override val name1="Nom 1"
    override val name2="Nom 2"
    override val name3="Nom 3"
    override val name4="Nom 4"
    override val name5="Nom 5"
    override val name6="Nom 6"
    override val name7="Nom 7"
    override val name8="Nom 8"
    override val name9="Nom 9"
    override val name10="Nom 10"
    override val creditCard="Carte de Crédit"
    override val cashFlow="Flux de Trésorerie"
    override val companyLogo="Logo de l'Entreprise"
    override val colorIsMissing="La couleur est manquante"
    override val titleFontColor="Couleur de police du titre"
    override val fontColor="Couleur de Police"
    override val preview="Aperçu"
    override val wideCompanyLogo="Logo large de l'entreprise"
    override val heroImage="Image héro"
    override val googleWallet="Google Wallet"
    override val appleWallet="Apple Wallet"
    override val website="Site Web"
    override val titleWebsite="Titre Site Web"
    override val telephoneNumber="Numéro de Téléphone"
    override val titleContact="Titre Contact"
    override val title2="Titre 2"
    override val titleField2="Titre Champ 2"
    override val title1="Titre 1"
    override val titleField1="Titre Champ 1"
    override val description="Description"
    override val emailCompany="Email Entreprise"
    override val activeCustomersCard="Les cartes clients mobiles sont actives"
    override val virtualCard="Carte Virtuelle"
    override val addNewLocation="Ajouter un nouvel emplacement"
    override val uploadFromPc="Télécharger depuis le Local"
    override val prompt="Invite"
    override val question="Votre Question"
    override val newImage="Nouvelle Image"
    override val newMenuCard="Nouvelle Carte de Menu"
    override val dataAssistant="Assistant de Données"
    override val price2="Prix 2"
    override val price1="Prix 1"
    override val numberDot="N°."
    override val addNewItem="Ajouter un nouvel élément"
    override val variant1="Variante 1"
    override val variant2="Variante 2"
    override val variant3="Variante 3"
    override val variant4="Variante 4"
    override val variant5="Variante 5"
    override val variant6="Variante 6"
    override val variant7="Variante 7"
    override val variant8="Variante 8"
    override val variant9="Variante 9"
    override val variant10="Variante 10"
    override val kitchenInformation="Information de Cuisine"
    override val items="Éléments"
    override val addNewSaleGroup="Ajouter un nouveau groupe de vente"
    override val submit="Soumettre"
    override val inactiveItems="Éléments Inactifs"
    override val activeItems="Éléments Actifs"
    override val allItems="Tous les Éléments"
    override val individualFilter="Filtre Individuel"
    override val creatingNewProduct="Ajouter un nouveau produit"
    override val numberOrNameIsWrong="Le numéro ou le nom est incorrect."
    override val products="Produits"
    override val companyProfile="Profil de l'Entreprise"
    override val imageAiDialogWaitingMsg="Le processus peut prendre plus de 30 s"
    override val menuCardAIDialogWaitingMsg="Le processus peut prendre plus de 3 m"
    override val generate="Générer"
    override val hint="Indice"
    override val allDays="Tous les Jours"
    override val mondayFull="Lundi"
    override val tuesdayFull="Mardi"
    override val wednesdayFull="Mercredi"
    override val thursdayFull="Jeudi"
    override val fridayFull="Vendredi"
    override val saturdayFull="Samedi"
    override val sundayFull="Dimanche"
    override val selectDays="Sélectionner les Jours"
    override val color="Couleur"
    override val changesValidFrom="Changements Valides À Partir De"
    override val surchargePercent="Supplément %"
    override val away="À Emporter"
    override val surchargeAmount="Montant du Supplément"
    override val priceLevels="Niveaux de Prix"
    override val surchargeInHouse="Supplément En Interne"
    override val contain="Contenir"
    override val allergens="Allergènes"
    override val deliveryTimeInDays="Jours de Livraison"
    override val minimumOrder="Commande Minimum"
    override val maximumOrder="Commande Maximum"
    override val vat="TVA"
    override val printKitchenReceiptIfInfoSelected="Imprimer le reçu de cuisine uniquement lorsque l'information de cuisine est sélectionnée"
    override val printKitchenReceiptIfInHouseActive="Imprimer le reçu de cuisine uniquement lorsque le bouton En Interne est activé"
    override val kitchen="Cuisine"
    override val restaurant="Restaurant"
    override val prices="Prix"
    override val discount="Remise"
    override val product="Produit"
    override val slash="/"
    override val noDiscountPossible="Articles nets clients (pas de remise possible)"
    override val employeeNetItems="Articles nets employés"
    override val employeeConsumption="Consommation employé"
    override val interimFinancialStatement="État Financier Intérimaire"
    override val enableUsersOnlyForTimeTracking="Activer les Utilisateurs Uniquement Pour le Suivi du Temps"
    override val allReceipts="Tous les Reçus"
    override val noAuthorization="Pas d'Autorisation"
    override val onlyOwnReceipts="Seulement Ses Propres Reçus"
    override val gastronomy="Gastronomie"
    override val shortName="Nom Court"
    override val addNewUser="Ajouter un nouvel utilisateur"
    override val addNewCategory="Ajouter une nouvelle catégorie"
    override val img="Image"
    override val menuCard="Carte du Menu"
    override val remove="Supprimer"
    override val confirm="Confirmer"
    override val cancel="Annuler"
    override val printName="Nom d'Impression"
    override val users="Utilisateurs"
    override val articleList="Liste d'Articles"
    override val operation="Opération"
    override val general="Général"
    override val userPhoto="Photo d'Utilisateur"
    override val title="Titre"
    override val filter="Filtre"
    override val fibuNormal="Fibu Normal"
    override val financialReduced="Réduit"
    override val accounting="Comptabilité"
    override val accountingPercent="Comptabilité 0%"
    override val article="Article"
    override val template="Modèle"
    override val options="Options"
    override val salesGroups="Groupes de Ventes"
    override val clickAndCollect="Cliquer&Collecter"
    override val update="Mettre à jour"
    override val DAYS_END="Fin de Journée"
    override val ADMINISTRATOR="Administrateur"
    override val MANAGER="Gestionnaire (Le gestionnaire peut accéder à d'autres utilisateurs)"
    override val NO_SALES_TRIGGER="Pas de Déclencheur de Ventes (Maison)"
    override val cancellationRight="Droits d'Annulation"
    override val receiptName="Nom du Reçu"
    override val password="Mot de passe"
    override val name="Nom"
    override val waitersCastle="Château des Serveurs"
    override val right="Droit"
    override val devices="Appareils"
    override val user="Utilisateur"
    override val search="Rechercher"
    override val number="Numéro"
    override val language="Langue"
    override val street="Rue"
    override val label="Étiquette"
    override val companyName="Nom de l'Entreprise"
    override val zip="Code Postal"
    override val city="Ville"
    override val APP_NAME_PART1="RunMy"
    override val APP_NAME_PART2="Setup"
    override val saturday: String = "Sa"
    override val sunday: String = "Di"
    override val monday: String = "Lu"
    override val tuesday: String = "Ma"
    override val wednesday: String = "Me"
    override val thursday: String = "Je"
    override val friday: String = "Ve"
    override val USER_NAME="Jens Lehman"
    override val COMPANY_NAME="HS-Soft AG"
    override val forgetYourPassword="Mot de passe oublié?"
    override val login="Se connecter"
    override val enterYourPassword="Mot de passe *"
    override val enterYourEmail="Entrez l'email *"
    override val status="Statut"
    override val spent="Dépensé"
    override val sec="sec"
    override val steps="Étapes"
    override val step="Étape"
    override val model="Modèle"
    override val tokens="Jetons"
    override val expertMode="Mode expert"
    override val arguments="Arguments"
    override val typeOrUseVoice="Commencez à taper ou utilisez votre voix"
    override val availableToDownloadUntil="Disponible au téléchargement jusqu'à"
    override val dataAssistantWelcomeMessage="Bonjour! Comment puis-je vous aider?"
    override val kuchen="Cuisine"
    override val buffet="Buffet"
    override val downloadExpired="Téléchargement expiré"
    override val receiptPrinterSettings="Imprimante de reçu"
    override val printerType="Type d'imprimante"
    override val printerConnectionTarget="Numéro de série / Adresse IP"
    override val kitchenSettings="Paramètres de cuisine"
    override val rooms="Salles"
    override val separateKitchenReport = "Rapport de cuisine séparé"
    override val kitchenStationAnnounce = "Annonce de station de cuisine"
    override val snOfKds = "Numéro de série KDS"
    override val companyNameEmptyHint="Un nom d'entreprise vide peut causer des erreurs sur votre site"
    override val forgetPassInfo: String = "Le code de vérification pour réinitialiser le mot de passe sera envoyé à cet e-mail."
    override val forgetPassInfo2: String = "Entrez le code de vérification qui a été envoyé à votre e-mail et définissez votre nouveau mot de passe."
    override val sendCode: String = "Envoyer le code"
    override val verificationCode: String = "Code de vérification*"
    override val newPassword: String = "Nouveau mot de passe*"
    override val confirmPassword: String = "Confirmer le mot de passe*"
    override val enterNewPassword: String = "Entrez le nouveau mot de passe"
    override val enterNewPasswordAgain: String = "Entrez à nouveau le mot de passe"
    override val updatePassword: String = "Mettre à jour le mot de passe"
    override val passwordRequirements: String = "Exigences du mot de passe"
    override val passwordReqLength: String = "Au moins 8 caractères"
    override val passwordReqLower: String = "Au moins une lettre minuscule"
    override val passwordReqUpper: String = "Au moins une lettre majuscule"
    override val passwordReqNumber: String = "Au moins un chiffre"
    override val passwordReqSpecial: String = "Au moins un caractère spécial"
    override val printEFTReceipt: String = "Imprimer le reçu EFT"
    override val addNewAlergene: String = "Ajouter un nouvel allergène"
    override val takeOver: String = "Reprendre"
    override val createCustomeAlergene: String = "Créer un allergène personnalisé"
    override val keyword: String = "Mot-clé"
    override val unit: String = "Unité"
    override val nutritionalValues: String = "Valeurs nutritionnelles"

    // Table types
    override val squaredTable: String = "Table Carrée"
    override val roundTable: String = "Table Ronde"
    
    // Element actions
    override val addElement: String = "Ajouter un Élément"
    override val editElement: String = "Modifier un Élément"
    
    // Interior design elements
    override val structure: String = "Structure"
    override val furniture: String = "Mobilier"
    override val interiorDecoration: String = "Décoration Intérieure"
    override val indicators: String = "Indicateurs"
    
    // Structure elements
    override val horizontalWall: String = "Mur Horizontal"
    override val verticalWall: String = "Mur Vertical"
    override val horizontalWindow: String = "Fenêtre Horizontale"
    override val verticalWindow: String = "Fenêtre Verticale"
    override val squaredColumn: String = "Colonne Carrée"
    override val roundedColumn: String = "Colonne Ronde"
    override val singleDoor: String = "Porte Simple"
    override val doubleDoors: String = "Portes Doubles"
    
    // Furniture elements
    override val chair: String = "Chaise"
    override val barStool: String = "Tabouret de Bar"
    override val armChair: String = "Fauteuil"
    override val twoSeaterSofa: String = "Canapé Deux Places"
    override val threeSeaterSofa: String = "Canapé Trois Places"
    override val cocktailBarTable: String = "Table de Cocktail/Bar"
    
    // Interior decoration elements
    override val tree: String = "Arbre"
    override val bush: String = "Buisson"
    override val plant: String = "Plante"
    
    // Indicator elements
    override val exit: String = "Sortie"
    override val wc: String = "WC"

    override val enterCompanyName: String = "Entrez le nom de l'entreprise"
    override val country: String = "Pays"
    override val kitchenStations: String = "Postes de Cuisine"
    override val writeNewRoomNameToAdd: String = "Écrivez un nouveau nom de pièce à ajouter"
    override val type = "Type"
    override val startDate = "Date de début"
    override val endDate = "Date de fin"
    override val startTime = "Heure de début"
    override val lambda_seconds = "Secondes d'utilisation Lambda"
    override val data_size_kbytes = "Taille des données Ko"
    override val is_premium = "Est Premium"
    override val file_count = "Nombre de fichiers"
    override val freeCredits = "Crédits gratuits"
    override val premiumCredits = "Crédits premium"
    override val freeCreditsInfo = "Utilisés pour les questions et opérations de base. Ces crédits se renouvellent chaque mois et ne peuvent pas être achetés."
    override val premiumCreditsInfo = "Utilisés pour des analyses avancées et des fonctionnalités d’IA. Achetez-en plus si nécessaire. Ces crédits n’expirent pas."
    override val creditsWarning = "sont presque épuisés"
    override val learnMore = "En savoir plus"
    override val topUpCredits = "Recharger des crédits"
    override val info = "Info"
    override val favorites = "Favoris"
}